<template>
<div style="border-radius:8px" class="card pt-0 mb-3 bg-white px-3 py-3">
    <div class="row">
        <div class="col-7 text-left">
            <h4 class="card-title pb-2 pt-2 mb-0">Report Upah Minimum Provinsi</h4>
        </div>
        <div class="col-5">
        </div>
    </div>
    <div class="row no-gutters">
        <div class="col-md-1">
            <hr class="border-primary"/>
        </div>
        <div class="col-md-11">
            <hr/>
        </div>
    </div>
    <div class="row mt-3 pb-5 no-gutters">
        <div class="col-12">
            <table class="table w-100 table-bordered table-light" style="border-color:gainsboro!important">
                <thead>
                    <tr>
                        <th style="border-color:gainsboro!important;text-align:center">Nama Provinsi</th>
                        <th style="border-color:gainsboro!important;text-align:center">Upah Minimum Provinsi</th>
                        <th style="border-color:gainsboro!important;text-align:center">UMP (persentase)</th>
                        <th style="border-color:gainsboro!important;text-align:center">Action</th>
                    </tr>
                </thead>
                <tbody v-if="datas.length != 0">
                    <tr v-for="(li, id) in datas" :key="id">
                        <td style="border-color:gainsboro!important" class="font-weight-bold">{{li.provinsi}}</td>
                        <td style="border-color:gainsboro!important;text-align:right">{{separatorRupiah(li.umr)}}</td>
                        <td style="border-color:gainsboro!important;text-align:right">{{separatorRupiah(li.totalUmr)}} ({{li.persentase}}%)</td>
                        <td style="border-color:gainsboro!important;text-align:center"><img @click="goDetail(id)" :src="pencilIcon" title="edit nama" style="cursor:pointer" width="24px" height="24px" class="ml-1"/></td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="3" class="text-center">
                            {{errMessage}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <CModal
        size="lg"
        :centered="true"
        color="white"
        :show.sync="editModal"
        :closeOnBackdrop="false"
        >
        <template #header-wrapper>
            <div class="headers-modal">
                <CRow>
                    <CCol sm="10">
                        <div>Upah Minimum Provinsi {{inputNama}}</div>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img :src="closeIcon" @click="editModal = false" style="cursor:pointer" width="20px" height="20px"/>
                    </CCol>
                </CRow>
            </div>
        </template>
        <template #body-wrapper>
            <div class="mb-5" style="padding-right:20px;padding-left:20px">
                <CRow>
                    <CCol sm="6">
                        <label>Nama Provinsi</label>
                        <input v-model="inputNama" class="form-control" placeholder="Nama Provinsi" disabled style="background-color:whitesmoke" />
                    </CCol>
                    <CCol sm="6">
                        <label>Upah Minimum Provinsi</label>
                        <input @input="rupiahMode()" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" v-model="inputUMP" class="form-control" placeholder="UMP" />
                    </CCol>
                </CRow>
                <CRow class="mt-3">
                    <CCol sm="6">
                        <label>Persentase dari UMP</label>
                        <input onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" v-model="inputPersentase" maxlength="3" class="form-control" placeholder="Persentase" />
                    </CCol>
                </CRow>
            </div>
            <CRow class="mt-5" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                <CCol sm="6">
                    <CButton style="width: 100%!important" @click="editModal = false" class="btn-cancel">Kembali</CButton>
                </CCol>
                <CCol sm="6">
                    <CButton style="width: 100%!important" @click="submitForm()" class="btn-edit-submit">Simpan</CButton>
                </CCol>
            </CRow>
        </template>
        <template #footer-wrapper><span></span></template>
    </CModal>
</div>
</template>
<script>
import {DataApi} from "../service/DataApi";
export default {
    data() {
        return {
            pencilIcon: require('../assets/menu/icon_pencil.svg'),
            closeIcon: require('../assets/menu/icon_close.svg'),

            editModal: false,
            inputNama: '',
            inputUMP: '',
            inputPersentase: '',
            inputUnix: '',

            datas: [],
            errMessage: ''
        }
    },
    watch: {
        inputUMP() {
            if(this.inputUMP == '' || this.inputUMP == 'Rp. 0') {
                this.inputPersentase = '0'
            }
        },
        editModal() {
            if(this.editModal == false) {
                this.inputNama = ''
                this.inputUMP = ''
                this.inputPersentase = ''
                this.inputUnix = ''
                this.$v.$reset()
            }
        }
    },
    methods: {
        getData() {
            let payload = {
                provinsi: ''
            }
            DataApi.post("magang/umr/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data
                }
                else {
                    this.datas = []
                    this.errMessage = response.message
                }
                this.$emit('flagUMP', true)
            })
        },
        goDetail(id) {
            let temp = this.datas[id]
            this.inputNama = temp.provinsi
            this.inputUMP = temp.umr
            this.inputPersentase = temp.persentase
            this.rupiahMode()
            this.inputUnix = temp.unix
            this.editModal = true
        },
        submitForm() {
            this.$emit('flagUMP', false)
            let umr = ''
            let persen = ''
            if(this.inputUMP == '') {
                umr = '0'
            } else {
                if(this.inputUMP[0] == 'R') {
                    let clear = this.inputUMP.replace("Rp. ", '')
                    let nom = ''
                    var i = 0
                    for(i=0;i<clear.length;i++) {
                        if(clear[i] == '.') {
                            //
                        } else {
                            umr += clear[i]
                        }
                    }
                }
            }
            if(this.inputPersentase == '') {
                persen = '0'
            } else {
                persen = this.inputPersentase
            }
            let payload = {
                persentase: persen,
                provinsi: this.inputNama,
                tipe: 'U',
                umr: umr,
                unix: this.inputUnix
            }
            DataApi.post("magang/umr/simpan", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.getData()
                    this.editModal = false
                }
            })
        },
        separatorRupiah(value) {
            let val = value.toString()
            let leng = val.length
            let sisa 	= leng % 3
            let rupiah 	= val.substr(0, sisa)
            let ribuan 	= val.substr(sisa).match(/\d{3}/g)
                
            if (ribuan) {
                let separator = sisa ? '.' : ''
                rupiah += separator + ribuan.join('.')
            }
            return 'Rp. ' +  rupiah 
        },
        rupiahMode() {
            var number_string = this.inputUMP.toString().replace(/[^,\d]/g, '')
            var split           = number_string.split(',')
            var sisa             = split[0].length % 3
            var rupiah             = split[0].substr(0, sisa)
            var ribuan             = split[0].substr(sisa).match(/\d{3}/gi)
            var prefix = "Rp. "
        
            // tambahkan titik jika yang di input sudah menjadi angka satuan ribuan
            if(ribuan){
                var separator = sisa ? '.' : '';
                rupiah += separator + ribuan.join('.');
            }
        
            rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
            let hasil = prefix == undefined ? rupiah : (rupiah ? 'Rp. ' + rupiah : '');
            this.inputUMP = hasil
        }
    },
    mounted() {
        this.getData()
        this.$emit('flagUMP', false)
    },
}
</script>
<style scoped>
.card-title {
    font-size: 14px;
    color: rgba(0, 0, 0, 1);
    height: 100%;
}
.btn-cancel {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-edit-submit {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
</style>